import { ACTION_PAYMENT_METHOD_SELECTED } from './types'

const selectPaymentMethod = (container, payload) => ({
    payload,
    type: ACTION_PAYMENT_METHOD_SELECTED,
})

export default selectPaymentMethod
